<template>
  <div class="modern-layout" :style="cssVars">

    <!-- HEADER -->
    <header class="header">
      <h1>{{ header?.title }}</h1>
      <p>{{ header?.subtitle }}</p>
    </header>

    <!-- NAV -->
    <nav class="nav">
      <router-link
        v-for="item in navigation"
        :key="item.path"
        :to="item.path"
        class="nav-item"
      >
        {{ item.label }}
      </router-link>
    </nav>

    <!-- CONTENT -->
    <main class="content">
      <slot />
    </main>

    <!-- FOOTER -->
    <footer class="footer">
      {{ footer?.text }}
    </footer>

  </div>
</template>

<script>

export default {

  name: 'ModernLayout',

  props: {

    theme: Object,

    header: Object,

    footer: Object,

    navigation: Array

  },

  computed: {

    cssVars () {
      return {

        '--primary': this.theme.primary || '#C42634',
        '--background': this.theme.background || '#ffffff',
        '--text': this.theme.text || '#000'

      }
    }

  }

}

</script>

<style scoped>

.modern-layout {

  background: var(--background);
  color: var(--text);

}

.header {

  padding: 40px;
  background: var(--primary);
  color: white;

}

.nav {

  padding: 20px;
  border-bottom: 1px solid #ddd;

}

.nav-item {

  margin-right: 20px;

}

.content {

  padding: 40px;

}

.footer {

  padding: 30px;
  background: #eee;

}

</style>
